import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Tabs, Tooltip } from "antd";
import { ROLL_CALL_API_BASE_URL } from "../../RollCall/RollCallConfig/RollCallConfig";

const KpiDetailView = ({ branchId, date }) => {
  const [kpiData, setKpiData] = useState({
    daily: [],
    weekly: [],
    monthly: [],
  });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("daily");
  const superId = sessionStorage.getItem("superId");

  useEffect(() => {
    if (!branchId || !date) return;
    console.log(branchId);
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/kpi/getkpiresponse?KPIGroup=0&BranchId=${branchId}&Fromdate=${date}&Todate=${date}&SuperId=${superId}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            },
          },
        );
        const data = await response.json();

        if (data.Status) {
          setKpiData({
            daily: data.ResultData.Daily || [],
            weekly: data.ResultData.Weekly || [],
            monthly: data.ResultData.Monthly || [],
          });

          if (data.ResultData.Daily?.length > 0) setActiveTab("daily");
          else if (data.ResultData.Weekly?.length > 0) setActiveTab("weekly");
          else if (data.ResultData.Monthly?.length > 0) setActiveTab("monthly");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [branchId, date]);

  const columns = [
    { title: "Metric", dataIndex: "MetricName", key: "MetricName" },
    {
      title: "Target",
      dataIndex: "Target",
      key: "Target",
      render: (text) =>
        text !== null && text !== undefined && text !== "" ? text : "-",
    },
    {
      title: "Achieved",
      dataIndex: "Achieved",
      key: "Achieved",
      render: (text) =>
        text !== null && text !== undefined && text !== "" ? text : "-",
    },
    {
      title: "Notes",
      dataIndex: "Notes",
      render: (text) => {
        return text ? (
          <Tooltip title={text}>
            <i
              className="fa-regular fa-note-sticky text-primary"
              style={{ cursor: "pointer", fontSize: "16px" }}
            />
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
  ];

  const tabItems = [
    kpiData.daily.length > 0 && {
      key: "daily",
      label: "Daily",
      children: (
        <Table columns={columns} dataSource={kpiData.daily} rowKey="id" />
      ),
    },
    kpiData.weekly.length > 0 && {
      key: "weekly",
      label: "Weekly",
      children: (
        <Table columns={columns} dataSource={kpiData.weekly} rowKey="id" />
      ),
    },
    kpiData.monthly.length > 0 && {
      key: "monthly",
      label: "Monthly",
      children: (
        <Table columns={columns} dataSource={kpiData.monthly} rowKey="id" />
      ),
    },
  ].filter(Boolean);

  return (
    <div>
      {loading ? (
        <div className="text-center py-5">
          <Spin size="large" />
        </div>
      ) : tabItems.length > 0 ? (
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
      ) : (
        <p className="text-center py-5">No KPI data available for this date</p>
      )}
    </div>
  );
};

KpiDetailView.propTypes = {
  branchId: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  //   onClose: PropTypes.func,
};

export default KpiDetailView;
